{
  "about.domain_blocks.suspended.title": "నిషేధించబడింది",
  "account.add_or_remove_from_list": "జాబితాల నుండి చేర్చు లేదా తీసివేయి",
  "account.badges.bot": "బాట్",
  "account.block": "@{name} ను బ్లాక్ చేయి",
  "account.block_domain": "{domain} నుంచి అన్నీ దాచిపెట్టు",
  "account.blocked": "బ్లాక్ అయినవి",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.edit_profile": "ప్రొఫైల్ని సవరించండి",
  "account.endorse": "ప్రొఫైల్లో చూపించు",
  "account.follow": "అనుసరించు",
  "account.followers": "అనుచరులు",
  "account.followers.empty": "ఈ వినియోగదారుడిని ఇంకా ఎవరూ అనుసరించడంలేదు.",
  "account.follows.empty": "ఈ వినియోగదారి ఇంకా ఎవరినీ అనుసరించడంలేదు.",
  "account.hide_reblogs": "@{name} నుంచి బూస్ట్ లను దాచిపెట్టు",
  "account.joined_short": "చేరారు",
  "account.link_verified_on": "ఈ లంకె యొక్క యాజమాన్యం {date}న పరీక్షించబడింది",
  "account.locked_info": "ఈ ఖాతా యొక్క గోప్యత స్థితి లాక్ చేయబడి వుంది. ఈ ఖాతాను ఎవరు అనుసరించవచ్చో యజమానే నిర్ణయం తీసుకుంటారు.",
  "account.media": "మీడియా",
  "account.mention": "@{name}ను ప్రస్తావించు",
  "account.mute": "@{name}ను మ్యూట్ చెయ్యి",
  "account.muted": "మ్యూట్ అయినవి",
  "account.posts": "టూట్లు",
  "account.report": "@{name}పై ఫిర్యాదుచేయు",
  "account.share": "@{name} యొక్క ప్రొఫైల్ను పంచుకోండి",
  "account.show_reblogs": "@{name}నుంచి బూస్ట్ లను చూపించు",
  "account.unblock": "@{name}పై బ్లాక్ ను తొలగించు",
  "account.unblock_domain": "{domain}ను దాచవద్దు",
  "account.unendorse": "ప్రొఫైల్లో చూపించవద్దు",
  "account.unfollow": "అనుసరించవద్దు",
  "account.unmute": "@{name}పై మ్యూట్ ని తొలగించు",
  "account_note.placeholder": "Click to add a note",
  "alert.unexpected.message": "అనుకోని తప్పు జరిగినది.",
  "alert.unexpected.title": "అయ్యో!",
  "boost_modal.combo": "మీరు తదుపరిసారి దీనిని దాటవేయడానికి {combo} నొక్కవచ్చు",
  "bundle_column_error.retry": "మళ్ళీ ప్రయత్నించండి",
  "bundle_modal_error.close": "మూసివేయు",
  "bundle_modal_error.retry": "మళ్ళీ ప్రయత్నించండి",
  "column.blocks": "బ్లాక్ చేయబడిన వినియోగదారులు",
  "column.community": "స్థానిక కాలక్రమం",
  "column.domain_blocks": "దాచిన డొమైన్లు",
  "column.follow_requests": "అనుసరించడానికి అభ్యర్ధనలు",
  "column.home": "హోమ్",
  "column.lists": "జాబితాలు",
  "column.mutes": "మ్యూట్ చేయబడిన వినియోగదారులు",
  "column.notifications": "ప్రకటనలు",
  "column.pins": "Pinned toot",
  "column.public": "సమాఖ్య కాలక్రమం",
  "column_back_button.label": "వెనక్కి",
  "column_header.hide_settings": "అమర్పులను దాచిపెట్టు",
  "column_header.moveLeft_settings": "నిలువు వరుసను ఎడమకి తరలించు",
  "column_header.moveRight_settings": "నిలువు వరుసను కుడికి తరలించు",
  "column_header.pin": "అతికించు",
  "column_header.show_settings": "అమర్పులను చూపించు",
  "column_header.unpin": "పీకివేయు",
  "community.column_settings.media_only": "మీడియా మాత్రమే",
  "compose_form.direct_message_warning_learn_more": "మరింత తెలుసుకోండి",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "మీ ఖాతా {locked} చేయబడలేదు. ఎవరైనా మిమ్మల్ని అనుసరించి మీ అనుచరులకు-మాత్రమే పోస్ట్లను వీక్షించవచ్చు.",
  "compose_form.lock_disclaimer.lock": "బిగించబడినది",
  "compose_form.placeholder": "మీ మనస్సులో ఏముంది?",
  "compose_form.poll.duration": "ఎన్నిక వ్యవధి",
  "compose_form.spoiler.marked": "హెచ్చరిక వెనుక పాఠ్యం దాచబడింది",
  "compose_form.spoiler.unmarked": "పాఠ్యం దాచబడలేదు",
  "confirmation_modal.cancel": "రద్దు చెయ్యి",
  "confirmations.block.confirm": "బ్లాక్ చేయి",
  "confirmations.delete.confirm": "తొలగించు",
  "confirmations.delete.message": "మీరు ఖచ్చితంగా ఈ స్టేటస్ ని తొలగించాలనుకుంటున్నారా?",
  "confirmations.delete_list.confirm": "తొలగించు",
  "confirmations.delete_list.message": "మీరు ఖచ్చితంగా ఈ జాబితాను శాశ్వతంగా తొలగించాలనుకుంటున్నారా?",
  "confirmations.mute.confirm": "మ్యూట్ చేయి",
  "confirmations.redraft.confirm": "తొలగించు & తిరగరాయు",
  "confirmations.unfollow.confirm": "అనుసరించవద్దు",
  "embed.instructions": "దిగువ కోడ్ను కాపీ చేయడం ద్వారా మీ వెబ్సైట్లో ఈ స్టేటస్ ని పొందుపరచండి.",
  "embed.preview": "అది ఈ క్రింది విధంగా కనిపిస్తుంది:",
  "emoji_button.activity": "కార్యకలాపాలు",
  "emoji_button.custom": "అనుకూలీకరించిన",
  "emoji_button.flags": "ఫ్లాగ్స్",
  "emoji_button.food": "ఆహారం & పానీయం",
  "emoji_button.label": "ఎమోజి చొప్పించు",
  "emoji_button.nature": "ప్రకృతి",
  "emoji_button.not_found": "ఎమోజీలు లేవు!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "వస్తువులు",
  "emoji_button.people": "ప్రజలు",
  "emoji_button.recent": "తరచుగా ఉపయోగించునవి",
  "emoji_button.search": "వెదుకు...",
  "emoji_button.search_results": "శోధన ఫలితాలు",
  "emoji_button.symbols": "చిహ్నాలు",
  "emoji_button.travel": "ప్రయాణం & ప్రదేశాలు",
  "empty_column.account_timeline": "ఇక్కడ ఏ టూట్లూ లేవు!No toots here!",
  "empty_column.blocks": "మీరు ఇంకా ఏ వినియోగదారులనూ బ్లాక్ చేయలేదు.",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.community": "స్థానిక కాలక్రమం ఖాళీగా ఉంది. మొదలుపెట్టడానికి బహిరంగంగా ఏదో ఒకటి వ్రాయండి!",
  "empty_column.domain_blocks": "దాచబడిన డొమైన్లు ఇంకా ఏమీ లేవు.",
  "empty_column.follow_requests": "మీకు ఇంకా ఫాలో రిక్వెస్టులు ఏమీ రాలేదు. మీకు ఒకటి రాగానే, అది ఇక్కడ కనబడుతుంది.",
  "empty_column.hashtag": "ఇంకా హాష్ ట్యాగ్లో ఏమీ లేదు.",
  "empty_column.home": "మీ హోమ్ కాలక్రమం ఖాళీగా ఉంది! {Public} ను సందర్శించండి లేదా ఇతర వినియోగదారులను కలుసుకోవడానికి మరియు అన్వేషణ కోసం శోధనను ఉపయోగించండి.",
  "empty_column.list": "ఇంకా ఈ జాబితాలో ఏదీ లేదు. ఈ జాబితాలోని సభ్యులు కొత్త స్టేటస్ లను పోస్ట్ చేసినప్పుడు, అవి ఇక్కడ కనిపిస్తాయి.",
  "empty_column.mutes": "మీరు ఇంకా ఏ వినియోగదారులనూ మ్యూట్ చేయలేదు.",
  "empty_column.notifications": "మీకు ఇంకా ఏ నోటిఫికేషన్లు లేవు. సంభాషణను ప్రారంభించడానికి ఇతరులతో ప్రతిస్పందించండి.",
  "empty_column.public": "ఇక్కడ ఏమీ లేదు! దీన్ని నింపడానికి బహిరంగంగా ఏదైనా వ్రాయండి, లేదా ఇతర సేవికల నుండి వినియోగదారులను అనుసరించండి",
  "follow_request.authorize": "అనుమతించు",
  "follow_request.reject": "తిరస్కరించు",
  "getting_started.heading": "మొదలుపెడదాం",
  "hashtag.column_header.tag_mode.all": "మరియు {additional}",
  "hashtag.column_header.tag_mode.any": "లేదా {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} లేకుండా",
  "hashtag.column_settings.select.no_options_message": "ఎటువంటి సూచనలూ దొరకలేదు",
  "hashtag.column_settings.select.placeholder": "హ్యాష్ టాగులు నింపండి…",
  "hashtag.column_settings.tag_mode.all": "ఇవన్నీ",
  "hashtag.column_settings.tag_mode.any": "వీటిలో ఏవైనా",
  "hashtag.column_settings.tag_mode.none": "ఇవేవీ కావు",
  "hashtag.column_settings.tag_toggle": "ఈ నిలువు వరుసలో మరికొన్ని ట్యాగులను చేర్చండి",
  "home.column_settings.show_reblogs": "బూస్ట్ లను చూపించు",
  "home.column_settings.show_replies": "ప్రత్యుత్తరాలను చూపించు",
  "keyboard_shortcuts.back": "వెనక్కి తిరిగి వెళ్ళడానికి",
  "keyboard_shortcuts.blocked": "బ్లాక్ చేయబడిన వినియోగదారుల జాబితాను తెరవడానికి",
  "keyboard_shortcuts.boost": "బూస్ట్ చేయడానికి",
  "keyboard_shortcuts.column": "నిలువు వరుసలలో ఒకదానిపై దృష్టి పెట్టడానికి",
  "keyboard_shortcuts.compose": "కంపోజ్ టెక్స్ట్ఏరియా పై దృష్టి పెట్టడానికి",
  "keyboard_shortcuts.down": "జాబితాలో క్రిందికి వెళ్ళడానికి",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "సమాఖ్య కాలక్రమాన్ని తెరవడానికి",
  "keyboard_shortcuts.heading": "కీబోర్డ్ సత్వరమార్గాలు",
  "keyboard_shortcuts.home": "హోమ్ కాలక్రమాన్ని తెరవడానికి",
  "keyboard_shortcuts.hotkey": "హాట్ కీ",
  "keyboard_shortcuts.legend": "ఈ లెజెండ్ ప్రదర్శించడానికి",
  "keyboard_shortcuts.local": "లోకల్ కాలక్రమాన్ని తెరవడానికి",
  "keyboard_shortcuts.mention": "రచయితను ప్రస్తావించడానికి",
  "keyboard_shortcuts.muted": "మ్యూట్ చేయబడిన వినియోగదారుల జాబితాను తెరవడానికి",
  "keyboard_shortcuts.my_profile": "మీ ప్రొఫైల్ను తెరవడానికి",
  "keyboard_shortcuts.notifications": "నోటిఫికేషన్ల నిలువు వరుసను తెరవడానికి",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "అతికించబడిన టూట్ల జాబితాను తెరవడానికి",
  "keyboard_shortcuts.profile": "రచయిత ప్రొఫైల్ ను తెరవాలంటే",
  "keyboard_shortcuts.reply": "ప్రత్యుత్తరం ఇవ్వడానికి",
  "keyboard_shortcuts.requests": "ఫాలో రిక్వెస్ట్ల జాబితాను తెరవడానికి",
  "keyboard_shortcuts.search": "శోధనపై దృష్టి పెట్టండి",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "\"ఇక్కడ ప్రారంభించండి\" నిలువు వరుసను తెరవడానికి",
  "keyboard_shortcuts.toggle_hidden": "CW వెనుక ఉన్న పాఠ్యాన్ని చూపడానికి / దాచడానికి",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "ఒక సరికొత్త టూట్ను ప్రారంభించడానికి",
  "keyboard_shortcuts.unfocus": "పాఠ్యం వ్రాసే ఏరియా/శోధన పట్టిక నుండి బయటకు రావడానికి",
  "keyboard_shortcuts.up": "జాబితాలో పైకి తరలించడానికి",
  "lightbox.close": "మూసివేయు",
  "lightbox.next": "తరువాత",
  "lightbox.previous": "మునుపటి",
  "lists.delete": "జాబితాను తొలగించు",
  "lists.edit": "జాబితాను సవరించు",
  "navigation_bar.blocks": "బ్లాక్ చేయబడిన వినియోగదారులు",
  "navigation_bar.domain_blocks": "దాచిన డొమైన్లు",
  "navigation_bar.filters": "మ్యూట్ చేయబడిన పదాలు",
  "navigation_bar.follow_requests": "అనుసరించడానికి అభ్యర్ధనలు",
  "navigation_bar.lists": "జాబితాలు",
  "navigation_bar.logout": "లాగ్ అవుట్ చేయండి",
  "navigation_bar.mutes": "మ్యూట్ చేయబడిన వినియోగదారులు",
  "navigation_bar.preferences": "ప్రాధాన్యతలు",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} మిమ్మల్ని అనుసరిస్తున్నారు",
  "notification.reblog": "{name} మీ స్టేటస్ ను బూస్ట్ చేసారు",
  "notifications.clear": "ప్రకటనలను తుడిచివేయు",
  "notifications.clear_confirmation": "మీరు మీ అన్ని నోటిఫికేషన్లను శాశ్వతంగా తొలగించాలనుకుంటున్నారా?",
  "notifications.column_settings.alert": "డెస్క్టాప్ నోటిఫికేషన్లు",
  "notifications.column_settings.follow": "క్రొత్త అనుచరులు:",
  "notifications.column_settings.mention": "ప్రస్తావనలు:",
  "notifications.column_settings.poll": "ఎన్నిక ఫలితాలు:",
  "notifications.column_settings.push": "పుష్ ప్రకటనలు",
  "notifications.column_settings.reblog": "బూస్ట్ లు:",
  "notifications.column_settings.show": "నిలువు వరుసలో చూపు",
  "notifications.column_settings.sound": "ధ్వనిని ప్లే చేయి",
  "notifications.column_settings.status": "New toots:",
  "notifications.filter.all": "అన్నీ",
  "notifications.filter.boosts": "బూస్ట్లు",
  "notifications.filter.follows": "అనుసరిస్తున్నవి",
  "notifications.filter.mentions": "పేర్కొన్నవి",
  "notifications.filter.polls": "ఎన్నిక ఫలితాలు",
  "notifications.group": "{count} ప్రకటనలు",
  "poll.closed": "మూసివేయబడినవి",
  "poll.refresh": "నవీకరించు",
  "poll.vote": "ఎన్నుకోండి",
  "poll_button.add_poll": "ఒక ఎన్నికను చేర్చు",
  "poll_button.remove_poll": "ఎన్నికను తొలగించు",
  "privacy.change": "స్టేటస్ గోప్యతను సర్దుబాటు చేయండి",
  "privacy.public.short": "ప్రజా",
  "relative_time.just_now": "ఇప్పుడు",
  "reply_indicator.cancel": "రద్దు చెయ్యి",
  "report.forward": "{target}కి ఫార్వార్డ్ చేయండి",
  "report.forward_hint": "ఖాతా మరొక సర్వర్లో ఉంది. నివేదిక యొక్క ఒక అనామకంగా ఉన్న కాపీని అక్కడికి కూడా పంపించమంటారా?",
  "report.placeholder": "అదనపు వ్యాఖ్యలు",
  "report.submit": "సమర్పించండి",
  "report.target": "{target}పై ఫిర్యాదు చేయండి",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "శోధన",
  "search_results.hashtags": "హాష్ ట్యాగ్లు",
  "search_results.statuses": "టూట్లు",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_account": "@{name} కొరకు సమన్వయ వినిమయసీమను తెరువు",
  "status.admin_status": "సమన్వయ వినిమయసీమలో ఈ స్టేటస్ ను తెరవండి",
  "status.block": "@{name} ను బ్లాక్ చేయి",
  "status.cancel_reblog_private": "బూస్ట్ను తొలగించు",
  "status.cannot_reblog": "ఈ పోస్ట్ను బూస్ట్ చేయడం సాధ్యం కాదు",
  "status.copy": "లంకెను స్టేటస్కు కాపీ చేయి",
  "status.delete": "తొలగించు",
  "status.detailed_status": "వివరణాత్మక సంభాషణ వీక్షణ",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "మరిన్ని లోడ్ చేయి",
  "status.media_hidden": "మీడియా దాచబడింది",
  "status.mention": "@{name}ను ప్రస్తావించు",
  "status.more": "ఇంకొన్ని",
  "status.mute": "@{name}ను మ్యూట్ చెయ్యి",
  "status.mute_conversation": "సంభాషణను మ్యూట్ చెయ్యి",
  "status.open": "ఈ స్టేటస్ ను విస్తరించు",
  "status.pin": "ప్రొఫైల్లో అతికించు",
  "status.read_more": "ఇంకా చదవండి",
  "status.reblog": "బూస్ట్",
  "status.reblogged_by": "{name} బూస్ట్ చేసారు",
  "status.reblogs.empty": "ఈ టూట్ను ఇంకా ఎవరూ బూస్ట్ చేయలేదు. ఎవరైనా చేసినప్పుడు, అవి ఇక్కడ కనబడతాయి.",
  "status.redraft": "తొలగించు & తిరగరాయు",
  "status.reply": "ప్రత్యుత్తరం",
  "status.replyAll": "సంభాషణకు ప్రత్యుత్తరం ఇవ్వండి",
  "status.report": "@{name}పై ఫిర్యాదుచేయు",
  "status.sensitive_warning": "సున్నితమైన కంటెంట్",
  "status.share": "పంచుకోండి",
  "status.show_less_all": "అన్నిటికీ తక్కువ చూపించు",
  "status.show_more_all": "అన్నిటికీ ఇంకా చూపించు",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.unmute_conversation": "సంభాషణను అన్మ్యూట్ చేయి",
  "status.unpin": "ప్రొఫైల్ నుండి పీకివేయు",
  "tabs_bar.home": "హోమ్",
  "tabs_bar.notifications": "ప్రకటనలు",
  "time_remaining.moments": "కొన్ని క్షణాలు మాత్రమే మిగిలి ఉన్నాయి",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "ui.beforeunload": "మీరు మాస్టొడొన్ను వదిలివేస్తే మీ డ్రాఫ్ట్లు పోతాయి.",
  "upload_area.title": "అప్లోడ్ చేయడానికి డ్రాగ్ & డ్రాప్ చేయండి",
  "upload_button.label": "మీడియాను జోడించండి (JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_progress.label": "అప్లోడ్ అవుతోంది...",
  "video.close": "వీడియోని మూసివేయి",
  "video.exit_fullscreen": "పూర్తి స్క్రీన్ నుండి నిష్క్రమించు",
  "video.expand": "వీడియోను విస్తరించండి",
  "video.fullscreen": "పూర్తి స్క్రీన్",
  "video.hide": "వీడియోను దాచు",
  "video.pause": "పాజ్ చేయి",
  "video.play": "ప్లే చేయి"
}
